import { types } from './types';
import { axiosGet } from '../../main/app-axios';

export const getAssociates = async ({ loja, cpf }) => dispatch => {

  const query = `?loja=${loja || ''}&cpf=${cpf || ''}`;

  return axiosGet(`/associado/${query}`, {}, dispatch).then(response => {
    
    if (response && response.status === 200) {
      dispatch({
        type: types.GET_ASSOCIATES,
        payload: {
          associates: response.data.data,
          loaded: true,
          error: false,
        },
      });
    } else {
      dispatch({
        type: types.GET_ASSOCIATES,
        payload: {
          loaded: false,
          error: true,
        },
      });
    }
  });
};
